/**
 * The local storage key which holds the id of the last system-wide user notification the user chose not to see again.
 */
export const SYSTEM_WIDE_USER_NOTIFICATION_HIDDEN = 'systemWideUserNotificationHidden';
/**
 * The identifier of the system-wide user notification.
 */
export const SYSTEM_WIDE_USER_NOTIFICATION_ID = 'SYSTEM_WIDE_USER_NOTIFICATION';
/**
 * The translation keys of the texts. The labels from the config are added to the language bundles under these keys.
 */
export const SYSTEM_WIDE_USER_NOTIFICATION_KEYS = {
    button: 'systemWideUserNotification.button',
    description: 'systemWideUserNotification.description',
    dontShowAgain: 'systemWideUserNotification.dontShowAgain',
    title: 'systemWideUserNotification.title'
};
